import { render } from "./UserGrowthChart.vue?vue&type=template&id=6d3c6950&scoped=true"
import script from "./UserGrowthChart.vue?vue&type=script&lang=js"
export * from "./UserGrowthChart.vue?vue&type=script&lang=js"

import "./UserGrowthChart.vue?vue&type=style&index=0&id=6d3c6950&scoped=true&lang=css"

import exportComponent from "../../../peelochat-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d3c6950"]])

export default __exports__